export default class GuideVehicle {
  constructor(
    model = "",
    licensePlate = "",
    year = "",
    modelYear = "",
    color = "",
    doors = "",
    fuelType = "",
    gasKit = false,
    ownVehicle = false,
    transmission = "",
    upholstery = "",
    insurance = false,
    thirdPartyInsurance = false,
    insuranceCompany = "",
    insuranceExpirationDate = null,
    observation = ""
  ) {
    this.model = model;
    this.licensePlate = licensePlate;
    this.year = year;
    this.modelYear = modelYear;
    this.color = color;
    this.doors = doors;
    this.fuelType = fuelType;
    this.gasKit = gasKit;
    this.ownVehicle = ownVehicle;
    this.transmission = transmission;
    this.upholstery = upholstery;
    this.insurance = insurance;
    this.thirdPartyInsurance = thirdPartyInsurance;
    this.insuranceCompany = insuranceCompany;
    this.insuranceExpirationDate = insuranceExpirationDate;
    this.observation = observation;
  }
}



// WEBPACK FOOTER //
// ./src/model/GuideVehicle.js